// main.tsx — avvio: caratteri, traduzioni, impostazioni del server, tempo reale, poi l'interfaccia.
import { StrictMode } from "react";
import { avviaNativo } from "./servizi/nativo.ts";
import { applicaTestoGrande } from "./servizi/testoGrande.ts";
import { createRoot } from "react-dom/client";

// Caratteri inclusi nell'app (niente servizi esterni: funzionano anche nelle app native senza rete).
import "@fontsource/bricolage-grotesque/600.css";
import "@fontsource/bricolage-grotesque/800.css";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/unbounded/600.css";
import "@fontsource/unbounded/800.css";
import "@fontsource/space-grotesk/400.css";
import "@fontsource/space-grotesk/700.css";
import "@fontsource/baloo-2/600.css";
import "@fontsource/baloo-2/800.css";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/600.css";
import "@fontsource/nunito/700.css";
import "@fontsource/nunito/800.css";
import "@fontsource/nunito/900.css";
// v019: il marchio, i timbri e i numeri grandi
import "@fontsource/lilita-one/400.css";
import "@fontsource/noto-sans-arabic/400.css";
import "@fontsource/noto-sans-arabic/700.css";
import "./stile.css";
import "./stile-laughdown.css";

import { App } from "./App.tsx";

applicaTestoGrande(); // v037: prima del primo disegno, niente salto
import { LimiteErrori } from "./componenti/LimiteErrori.tsx";
import i18n, { avviaI18n, cambiaLingua } from "./i18n/index.ts";
import { caricaImpostazioni, eElencoTesti, eTesto, leggiImpostazione } from "./servizi/impostazioni.ts";
import { tempoReale } from "./servizi/tempoReale.ts";
import { avviaAggiornamento } from "./servizi/aggiornamento.ts";
import { raccogliErrori } from "./servizi/errori.ts";
import { leggiPreferenza } from "./servizi/preferenze.ts";
import { applicaTema, temaIniziale } from "./temi/useTema.ts";
import { ID_TEMI } from "./temi/temi.ts";
import { scegliLingua, LINGUE_SUPPORTATE, LINGUA_RIPIEGO } from "../../condiviso/lingue.ts";
import { IMP_APP, PREFERENZE } from "./costanti.ts";

raccogliErrori();

// Il tema salvato si applica subito, prima di qualsiasi rete: niente lampo di colori sbagliati.
applicaTema(temaIniziale("", [...ID_TEMI]), "automatico", window.matchMedia?.("(prefers-color-scheme: dark)").matches === true);

// Lingua: prima quella scelta in passato, poi quelle del telefono. Si decide senza aspettare la rete,
// così l'interfaccia compare subito (anche se il server è irraggiungibile).
const preferenzeLingua = [leggiPreferenza(PREFERENZE.lingua) ?? "", ...(navigator.languages ?? [navigator.language])];
await avviaI18n(scegliLingua(preferenzeLingua, LINGUE_SUPPORTATE, LINGUA_RIPIEGO));

createRoot(document.getElementById("radice")!).render(
  <StrictMode>
    <LimiteErrori>
      <App />
    </LimiteErrori>
  </StrictMode>,
);

tempoReale.avvia();
avviaAggiornamento(); // v040: una versione nuova sul server → la pagina si ricarica (fuori dalla partita)
void avviaNativo(); // v030: barra di stato, schermata d'avvio, tastiera, tasto indietro (solo nelle app)

// Quando arrivano le impostazioni del server: se la lingua in uso è stata disattivata, se ne sceglie un'altra.
void caricaImpostazioni().then(async () => {
  const attive = leggiImpostazione<string[]>(IMP_APP.lingueAttive, [...LINGUE_SUPPORTATE], eElencoTesti);
  const predefinita = leggiImpostazione(IMP_APP.linguaPredefinita, LINGUA_RIPIEGO as string, eTesto);
  if (!attive.includes(i18n.language)) await cambiaLingua(scegliLingua(preferenzeLingua, attive, predefinita));
});
